import { ROOT } from "../../../utils/constants/routes";
import Logo from "../Logo";

import styles from "./index.module.scss";

function Footer() {
  return (
    <footer className={styles.container}>
      <Logo pathname={ROOT} />
    </footer>
  );
}

export default Footer;
